export function isTradePoint(department) {
    return ![
        "Ofis",
        "Dostavka",
        "Proizvodstvo",
        "Sklad",
    ].includes(department);
}
